
export class Tuple<T, U> {

	public Item1: T;
	public Item2: U;

	constructor(item1: T, item2: U) {
		this.Item1 = item1;
		this.Item2 = item2;
	}
}
